module.exports = __webpack_public_path__ + "img/blank-profile.5a021ab9.png";